var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerfilSeleccionIcon02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 118.099,
    height: 80.225,
    viewBox: "0 0 118.099 80.225",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_510",
    "data-name": "Grupo 510",
    transform: "translate(-737.584 -540.459)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_503",
    "data-name": "Grupo 503",
    transform: "translate(-142.27 47.929)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "person-add",
    transform: "translate(917.728 492.53)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_214",
    "data-name": "Trazado 214",
    d: "M957.841,532.643a20.056,20.056,0,1,0-20.056-20.056A20.116,20.116,0,0,0,957.841,532.643Zm0,10.028c-13.538,0-40.113,6.518-40.113,20.056v10.028h80.225V562.727C997.953,549.189,971.379,542.671,957.841,542.671Z",
    transform: "translate(-917.728 -492.53)",
    fill: "#3a5fa1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_504",
    "data-name": "Grupo 504",
    transform: "translate(543.9 -195.142)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_216",
    "data-name": "Trazado 216",
    d: "M220.867,749.4l8.892,8.892L207.251,780.8l-8.889-8.892Zm15.64-2.145-3.965-3.965a3.937,3.937,0,0,0-5.559,0l-3.8,3.8,8.892,8.892,4.43-4.43A3.032,3.032,0,0,0,236.506,747.255Zm-42.8,37.152a1.012,1.012,0,0,0,1.225,1.2l9.908-2.4-8.887-8.892Z",
    fill: "#3a5fa1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerfilSeleccionIcon02);
export default __webpack_public_path__ + "static/media/perfil-seleccion-icon-02.4ac10425b7f2991e58c06f44273c83a7.svg";
export { ForwardRef as ReactComponent };